// Copy paste from example in documentation
// See https://jqueryui.com/autocomplete/#categories
$.widget('custom.autocompleteOwner', $.ui.autocomplete, {
    _create() {
        this._super();
    },
    _renderMenu(ul, items) {
        ul.addClass('M-customerAutocomplete__menu');
        $.each(items, (index, item) => {
            const li = this._renderItemData(ul, item);
            li.attr('aria-label', `${item.label}`);
        });
    },
    _renderItem(ul, item) {
        return $('<li class="M-searchAutocomplete__menuItem">').html(item.labelHtml).appendTo(ul);
    },
});

Bingo.OwnerAutocomplete = class {
    constructor($wrapper, options) {
        const defaults = {
            btnClearSelector: '.js-textField__searchReset',
            filledClass: '-filled',
            companyInputNames: ['company_name', 'trade_reg_no', 'company_type'],
            personInputNames: ['firstname', 'lastname', 'email', 'phone'],

            companyLabelItems: ['companyName', 'tradeRegNo'],
            personLabelItems: ['firstname', 'lastname', 'email', 'phone'],

            namespace: null,
            personNamespace: 'contact_person',

            customerInputSelector: '[name="customer_id"]',
            companyInputSelector: '[name="company_id"]',
            personInputSelector: '[name="contact_person[person_id]"]',

            additionalCompanyClear: ['#js-company-detail'],
            additionalPersonClear: ['#js-contact-person'],
        };

        this.options = $.extend(defaults, options);
        this.wrapper = $wrapper;
        this.btnClear = $wrapper.find(this.options.btnClearSelector);
        this.searchCompanyUrl = this.wrapper.attr('data-owner-company-autocomplete-search-url');
        this.searchPersonUrl = this.wrapper.attr('data-owner-person-autocomplete-search-url');
        this.customerIdInput = $(this.options.customerInputSelector);
        this.companyIdInput = $wrapper.find(this.options.companyInputSelector);
        this.personIdInput = $wrapper.find(this.options.personInputSelector);
        this.companyInputs = [];
        this.personInputs = [];
        this.customerInputs = [];
        this._type = null;

        const getInputs = (inputName, namespace) => {
            if (namespace) {
                return this.wrapper.find('[name="'.concat(namespace, '[', inputName, ']', '"]'));
            }
            return this.wrapper.find('[name="'.concat(inputName, '"]'));
        };

        this.companyInputs = this.options.companyInputNames.map(item => getInputs(item));
        this.personInputs = this.options.personInputNames.map(item => getInputs(item, this.options.personNamespace));
        this.customerInputs = this.companyInputs.concat(this.personInputs);

        this.btnClear.on('click', (e) => {
            e.stopImmediatePropagation();
            this.clearAutocomplete();
        });


        addAutocomplete = (input, isPerson) => {
            input.autocompleteOwner({
                minLength: 3,
                source: (request, response) => {
                    // Load new suggestions
                    this.loadSuggestions(request.term, input.attr('name'), isPerson).then((data) => {
                        response(data); // Update jquery autocomplete
                    });
                },
                select: (event, ui) => {
                    const data = ui.item.data;
                    this.wrapper.data('selected-item', data);
                    if (isPerson && !data.contact_person) {
                        this.selectSuggestion(data, this.options.personNamespace);
                    } else {
                        this.selectSuggestion(data, this.options.namespace);
                    }
                    return false;
                },
                position: {
                    my: 'left+0 top+2',
                },
            });
        };

        for (const i in this.companyInputs) {
            addAutocomplete(this.companyInputs[i], false);
        }

        for (const i in this.personInputs) {
            addAutocomplete(this.personInputs[i], true);
        }
    }

    /**
     * Loads new suggestions from API
     * @param text Search phrase
     * @param fieldName Field name
     * @return Promise
     */
    loadSuggestions(text, fieldName, isPerson) {
        removeBracket = (textToRemove) => {
            if (textToRemove.includes('[') && textToRemove.includes(']')) {
                return removeBracket(textToRemove.match(/\[(.*?)\]/)[1]);
            }
            return textToRemove;
        };

        ajaxData = {
            field: removeBracket(fieldName),
            value: text,
        };

        return $.nette.ajax({
            type: 'GET',
            url: isPerson ? this.searchPersonUrl : this.searchCompanyUrl,
            data: ajaxData,
        }).then((payload, status, jqXHR) => {
            if (payload.status.code !== 1) {
                Bingo.AjaxFailed.showError(payload.status.message);
                return $.Deferred().reject(jqXHR); // Reject promise
            }

            return payload.data;
        }).then((suggestions) => {
            let data = [];

            // Transform API response to data for autocomplete [{label, labelHtml, description, data}]
            for (const i in suggestions) {
                let suggestedData = null;
                let suggest = [];
                // Is company
                if (suggestions[i].company) {
                    suggestions[i].company.contact_person = suggestions[i].person;
                    suggestedData = suggestions[i].company;
                    if (suggestedData.contact_person === null) {
                        suggestedData._type = 'company';
                    } else {
                        suggestedData._type = 'customer';
                        suggestedData._customer_id = suggestions[i].id;
                    }

                    suggest = this.options.companyLabelItems.map(item => suggestions[i].company[item]);
                    if (suggestedData.contact_person) {
                        suggest = suggest.concat(this.options.personLabelItems.map(item2 => suggestedData.contact_person[item2]));
                    }
                // Is person
                } else if (suggestions[i].person) {
                    suggestedData = suggestions[i].person;
                    suggestedData._type = 'person';
                    suggest = this.options.personLabelItems.map(item => suggestions[i].person[item]);
                }
                suggest = suggest.filter(element => element != null);

                const suggestDescription = suggest.join(', ');

                data = data.concat({
                    label: suggestedData[fieldName],
                    labelHtml: this.constructor.highlightSearchText(suggestDescription, text),
                    description: suggestDescription,
                    data: suggestedData,
                });
            }
            return data;
        });
    }

    /**
     * @param data
     * @param namespace
     */
    selectSuggestion(data, namespace) {
        const camelToUnderscore = camelText => camelText.replace(/(?:^|\.?)([A-Z])/g, (x, y) => '_'.concat(y.toLowerCase())).replace(/^_/, '');

        switch (data._type) {
            case 'company':
                this.companyIdInput.val(data.id);
                break;
            case 'customer':
                this.companyIdInput.val(data.id);
                this.personIdInput.val(data.id);
                this.customerIdInput.val(data._customer_id);
                break;
            case 'person':
                this.personIdInput.val(data.id);
                break;
            default:
        }

        for (const name in data) {
            if (typeof data[name] === 'object' && data[name] !== null) {
                this.selectSuggestion(data[name], camelToUnderscore(name));
            }
            let inputName = camelToUnderscore(name);
            if (namespace) {
                inputName = namespace.concat('[', inputName, ']');
            }
            const input = this.wrapper.find("[name='".concat(inputName, "']"));

            if (input) {
                if (input.attr('type') === 'radio') {
                    input.each((index, item) => {
                        if ($(item).attr('value') === data[name].toString()) {
                            $(item).prop('checked', true).trigger('change');
                        }
                    });
                } else if (input.hasClass('mdb-select')) {
                    if (data[name] !== null) {
                        const optionName = input.find(`option[value="${data[name]}"]`).text();
                        input.parent().find(`li:contains("${optionName}")`).click();
                    } else {
                        input.parent().find('li:first-child').click();
                    }
                } else if (inputName === 'company_address[country]') {
                    input[0].selectize.setValue(data[name]);
                    input.trigger('change').trigger('updateProxyValue');
                } else {
                    input.val(data[name]).trigger('change').trigger('updateProxyValue');
                }
            }
        }

        this._type = data._type;
        this.disable();
    }

    /**
     * Clear autocomplete
     */
    clearAutocomplete() {
        this.clear();
    }

    /**
     * Disable search input
     */
    disable() {
        disableInput = (input) => {
            input.prop('disabled', true);
            input.closest('.js-textField').addClass(this.options.filledClass);
        };

        disableAdditional = (item) => {
            const inputs = $(item).find('input:text, select, input[type="date"], textarea');
            inputs.each((index, input) => {
                disableInput($(input));
            });
        };

        switch (this._type) {
            case 'company':
                this.companyInputs.forEach(disableInput);
                this.options.additionalCompanyClear.forEach(disableAdditional);
                break;
            case 'customer':
                this.customerInputs.forEach(disableInput);
                this.options.additionalCompanyClear.forEach(disableAdditional);
                this.options.additionalPersonClear.forEach(disableAdditional);
                break;
            case 'person':
                this.personInputs.forEach(disableInput);
                this.options.additionalPersonClear.forEach(disableAdditional);
                break;
            default:
        }
    }

    /**
     * Clear search input
     */
    clear() {
        const clearInput = (input) => {
            input.val('');
            input.prop('disabled', false);
            input.prop('checked', false);
            input.trigger('change');
            input.closest('.js-textField').removeClass(this.options.filledClass);
        };

        const additionalClear = (item) => {
            const inputs = $(item).find('input:text, select, input[type="date"], textarea');
            inputs.each((index, input) => {
                clearInput($(input));
            });
        };

        this.customerInputs.forEach(clearInput);
        this.options.additionalCompanyClear.forEach(additionalClear);
        this.options.additionalPersonClear.forEach(additionalClear);
        this.customerIdInput.val('');
        this.companyIdInput.val('');
        this.personIdInput.val('');
    }

    /**
     * Returns html string with search text wrapped in <strong>
     * @param suggestion
     * @param searchText
     * @return string
     */
    static highlightSearchText(suggestion, searchText) {
        const searchTextEsc = '('.concat(searchText.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'), ')');
        return suggestion.replace(new RegExp(searchTextEsc, 'ig'), '<strong>$1</strong>');
    }
};
